
/**
 * For Node.js, simply re-export the core `util.deprecate` function.
 */

module.exports = require('util').deprecate;



//////////////////
// WEBPACK FOOTER
// ../node_modules/util-deprecate/node.js
// module id = ../node_modules/util-deprecate/node.js
// module chunks = 5